import React from "react";
import { Empty, Spin, Row, Col } from "antd";
import TaskTemplateCard from "./TaskTemplateCard";
import { TaskTemplate } from "../../../../../types/taskTemplate";

interface TaskTemplateGridProps {
  templates: TaskTemplate[];
  loading?: boolean;
  onEdit: (template: TaskTemplate) => void;
  onDelete: (id: string) => void;
  onSetDefault: (id: string) => void;
}

const TaskTemplateGrid: React.FC<TaskTemplateGridProps> = ({
  templates,
  loading,
  onEdit,
  onDelete,
  onSetDefault,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "48px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div style={{ padding: "48px 0" }}>
        <Empty
          description="No task templates found"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );
  }

  return (
    <Row gutter={[24, 24]}>
      {templates.map((template) => (
        <Col key={template.id} xs={24} sm={12} lg={8} xl={6}>
          <TaskTemplateCard
            template={template}
            onEdit={onEdit}
            onDelete={onDelete}
            onSetDefault={onSetDefault}
          />
        </Col>
      ))}
    </Row>
  );
};

export default TaskTemplateGrid;
